import React, { Component } from 'react';

import Button from 'fuse-ui/components/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Typography from 'fuse-ui/components/Typography';
import greyscale from '../../common/theme/colors/greyscale';
import { withStyles } from '@material-ui/core/styles';


const styles = theme => ( {
    btn: {
        marginBottom: theme.spacing.unit * 2
    },
    btnGroup: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 35,
        paddingLeft: 40,
        paddingRight: 40,
        textAlign: 'center',
    },
    canvasPreview: {
        backgroundColor: greyscale[100],
        height: 175
    },
    canvasTile: {
        border: 'none',
        boxShadow: theme.shadows[1],
        cursor: 'pointer',
        height: 225,
    },
} );

class CanvasTile extends Component{
    constructor( props ){
        super( props );

        this.state = {
            showCanvasActions: false,
        };
    }

    handleHideCanvasActions = () => {
        this.setState( { showCanvasActions: false } );
    }

    handleShowCanvasActions = () => {
        this.setState( { showCanvasActions: true } );
    }

    render(){
        const { classes, id, match, name } = this.props;
        const { showCanvasActions } = this.state;
        const canvasActionButtons = (
            <div className={classes.btnGroup}>
                <Button
                    className={classes.btn}
                    color="primary"
                    component={Link}
                    to={`${match.url}/canvas/${id}`}
                    variant="contained"
                >
                    View
                </Button>
                <Button
                    className={classes.btn}
                    variant="outlined"
                    color="secondary"
                >
                    Share
                </Button>
            </div>
        );

        return (
            <Grid item xs={6} sm={4} md={3} lg={2}>
                <Card
                    className={classes.canvasTile}
                    onMouseEnter={this.handleShowCanvasActions}
                    onMouseLeave={this.handleHideCanvasActions}
                >
                    <CardContent className={classes.canvasPreview}>
                        {showCanvasActions && canvasActionButtons}
                    </CardContent>
                    <CardActions>
                        <Typography>{name}</Typography>
                    </CardActions>
                </Card>
            </Grid>
        );
    }
};

CanvasTile.propTypes = {
    classes: PropTypes.object.isRequired,
    id: PropTypes.number.isRequired,
    match: PropTypes.shape( {
        params: PropTypes.object,
        url: PropTypes.string,
    } ),
    name: PropTypes.string.isRequired
};

export default withStyles( styles )( CanvasTile );
